import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { useState } from 'react';
import styled from 'styled-components';
import RectangularBigBtn from '../../../../components2/Buttons/RectangularbigBtn';

export default function ShortAnswerDialog({
  shortAnswer,
  setShortAnswerPreviewDialog,
  showActionButton = false,
  onActionButtonClick = () => {},
}) {
  const [isDialogOpen, setIsDialogOpen] = useState(true);

  const closeDialog = () => {
    setIsDialogOpen(false);
    setShortAnswerPreviewDialog(false);
  };

  const importShortAnswer = () => {
    onActionButtonClick();
    setShortAnswerPreviewDialog(false);
  };

  const sortedCriterias = shortAnswer?.criterias?.slice().sort((a, b) => b.marks - a.marks) || [];

  return (
    <>
      <Dialog
        open={isDialogOpen}
        onClose={closeDialog}
        maxWidth="md"
        PaperProps={{ style: { width: 700 } }}
        sx={{ zIndex: 2147483647 }}
      >
        <DialogContent>
          {shortAnswer?.title && (
            <TitleContainer>
              <TitleText>{shortAnswer.title}</TitleText>
            </TitleContainer>
          )}
          <HeaderRow>
            <MarksHeader>Marks</MarksHeader>
            <CriteriaHeader>Criteria</CriteriaHeader>
          </HeaderRow>
          <CriteriasContainer>
            {sortedCriterias.length > 0 ? (
              sortedCriterias.map((criteria, idx) => (
                <CriteriaRow key={idx}>
                  <MarksBox>{criteria.marks}</MarksBox>
                  <CriteriaBox>{criteria.criteria}</CriteriaBox>
                </CriteriaRow>
              ))
            ) : (
              <EmptyMessage>No criteria available</EmptyMessage>
            )}
          </CriteriasContainer>
          {showActionButton && (
            <ActionButtonContainer>
              <RectangularBigBtn text="Import" onClickFn={importShortAnswer} />
            </ActionButtonContainer>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}

const ActionButtonContainer = styled.div`
  margin-top: 16px;
`;

const TitleContainer = styled.div`
  margin-bottom: 20px;
`;

const TitleText = styled.h3`
  font-family: IBM Plex Sans;
  font-size: 19px;
  font-weight: 500;
  color: #1e252a;
  margin: 0;
`;

const HeaderRow = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 12px;
  padding-left: 8px;
`;

const MarksHeader = styled.span`
  font-family: IBM Plex Sans;
  font-size: 14px;
  font-weight: 600;
  color: #4B464F;
  width: 50px;
`;

const CriteriaHeader = styled.span`
  font-family: IBM Plex Sans;
  font-size: 14px;
  font-weight: 600;
  color: #4B464F;
  flex: 1;
`;

const CriteriasContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const CriteriaRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
`;

const MarksBox = styled.div`
  width: 50px;
  min-height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #C9C6CC;
  border-radius: 6px;
  font-family: IBM Plex Sans;
  font-size: 16px;
  font-weight: 500;
  color: #1e252a;
  flex-shrink: 0;
`;

const CriteriaBox = styled.div`
  flex: 1;
  /* min-width:0 lets this flex child shrink so long criteria wrap instead of
     overflowing the fixed-width dialog; align-items:flex-start + auto height
     lets the box grow with wrapped text rather than overlapping rows (JED-1083). */
  min-width: 0;
  min-height: 44px;
  display: flex;
  align-items: flex-start;
  padding: 10px 16px;
  border: 1px solid #C9C6CC;
  border-radius: 6px;
  font-family: IBM Plex Sans;
  font-size: 16px;
  line-height: 1.5;
  color: #1e252a;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
`;

const EmptyMessage = styled.p`
  font-family: IBM Plex Sans;
  font-size: 14px;
  color: #7b7382;
  padding: 16px;
  text-align: center;
`;
